import { loadElementLazyImage } from './helpers/lazy-load'



$(document).ready(function() {

  $('.js-play-video').click(function (){
    let video = $(this).parent().find('video')
    loadElementLazyImage(video)
    $(this).fadeOut()
  })
})


